import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const aids: AnswerPathTreeNode = {
  path: 'aids',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAidsDetails }],
};
